module.exports = __webpack_public_path__ + "static-portal/img/4.0bd812f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/4.jpg
// module id = CtaL
// module chunks = 4